import { defineMessages } from 'react-intl-next';

export const i18n: {
	assignee: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterContributorPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterAssigneeLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraFilterAssigneeLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	assignee: {
		id: 'search-page.filters.names.assignee',
		defaultMessage: 'Assignee',
		description: 'Label for filtering by assignee',
	},
	jiraFilterContributorPlaceholder: {
		id: 'search-page.jira.filter.assignee.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for assignee filter search input',
	},
	jiraFilterAssigneeLabelSelected: {
		id: 'search-page.jira.filter.assignee.selected',
		defaultMessage: 'Selected',
		description: 'Jira assignee filter selected label',
	},
	jiraFilterAssigneeLabelUnselected: {
		id: 'search-page.jira.filter.assignee.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira assignee filter unselected label',
	},
});
